export const TrackIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 17.5H2.75C2.02065 17.5 1.32118 17.2103 0.80546 16.6945C0.28973 16.1788 0 15.4793 0 14.75V2.75C0 2.02065 0.28973 1.32118 0.80546 0.80546C1.32118 0.28973 2.02065 0 2.75 0H8.75C8.9489 0 9.1397 0.0790201 9.2803 0.21967C9.421 0.36032 9.5 0.55109 9.5 0.75C9.5 0.94891 9.421 1.13968 9.2803 1.28033C9.1397 1.42098 8.9489 1.5 8.75 1.5H2.75C2.41848 1.5 2.10054 1.6317 1.86612 1.86612C1.6317 2.10054 1.5 2.41848 1.5 2.75V14.75C1.5 15.0815 1.6317 15.3995 1.86612 15.6339C2.10054 15.8683 2.41848 16 2.75 16H14.75C15.0815 16 15.3995 15.8683 15.6339 15.6339C15.8683 15.3995 16 15.0815 16 14.75V8.75C16 8.5511 16.079 8.3603 16.2197 8.2197C16.3603 8.079 16.5511 8 16.75 8C16.9489 8 17.1397 8.079 17.2803 8.2197C17.421 8.3603 17.5 8.5511 17.5 8.75V14.75C17.5 15.4793 17.2103 16.1788 16.6945 16.6945C16.1788 17.2103 15.4793 17.5 14.75 17.5Z"
      fill="#FF8500"
    />
    <path
      d="M4.75 5.5C4.5519 5.49741 4.3626 5.41756 4.2225 5.27747C4.0824 5.13737 4.0026 4.94811 4 4.75V1.5H0.75C0.5511 1.5 0.3603 1.42098 0.2197 1.28033C0.0789999 1.13968 0 0.94891 0 0.75C0 0.55109 0.0789999 0.36032 0.2197 0.21967C0.3603 0.0790201 0.5511 0 0.75 0H4.75C4.9481 0.00259 5.1374 0.0824399 5.2775 0.22253C5.4176 0.36263 5.4974 0.55189 5.5 0.75V4.75C5.4974 4.94811 5.4176 5.13737 5.2775 5.27747C5.1374 5.41756 4.9481 5.49741 4.75 5.5Z"
      fill="#FF8500"
    />
    <path
      d="M1.24996 8.00006C1.05706 7.98526 0.87756 7.89556 0.74996 7.75006C0.62696 7.61256 0.55896 7.43456 0.55896 7.25006C0.55896 7.06556 0.62696 6.88756 0.74996 6.75006L7.24996 0.25006C7.31866 0.17637 7.40146 0.11727 7.49346 0.0762797C7.58546 0.0352897 7.68476 0.0132496 7.78546 0.0114696C7.88616 0.00968963 7.98616 0.0282197 8.07956 0.0659397C8.17296 0.10366 8.25776 0.1598 8.32896 0.23102C8.40026 0.30224 8.45636 0.38707 8.49406 0.48046C8.53176 0.57385 8.55036 0.67388 8.54856 0.77458C8.54676 0.87529 8.52476 0.974599 8.48376 1.0666C8.44276 1.1586 8.38366 1.2414 8.30996 1.31006L1.74996 7.75006C1.62236 7.89556 1.44286 7.98526 1.24996 8.00006Z"
      fill="#FF8500"
    />
  </svg>
);

export const ShippingIcon = () => (
  <svg
    width="114"
    height="66"
    viewBox="0 0 114 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M81.66 53.86H55.64"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M32.47 53.86H20.51"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M27.35 1H84.92C86.76 1 88.48 1.93 89.49 3.48L103.15 24.46C103.75 25.38 104.51 26.18 105.39 26.82L109.99 30.17C112.02 31.65 113.22 34 113.22 36.51V49.94C113.22 52.1 111.47 53.86 109.3 53.86H105.3"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M13.01 14.84H36.02"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M26.34 29.85H1"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M24.51 41.1801H7"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M104.05 25.84H74.87C73.12 25.84 71.7 24.42 71.7 22.67V1"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M44.46 65.0299C50.6291 65.0299 55.63 60.029 55.63 53.8599C55.63 47.6909 50.6291 42.6899 44.46 42.6899C38.291 42.6899 33.29 47.6909 33.29 53.8599C33.29 60.029 38.291 65.0299 44.46 65.0299Z"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M93.3599 65.0299C99.529 65.0299 104.53 60.029 104.53 53.8599C104.53 47.6909 99.529 42.6899 93.3599 42.6899C87.1909 42.6899 82.1899 47.6909 82.1899 53.8599C82.1899 60.029 87.1909 65.0299 93.3599 65.0299Z"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const BookingIcon = () => (
  <svg
    width="67"
    height="67"
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 22.73H66.18M22.73 44.46L29.97 51.7L44.45 37.22M15.48 1V8.24M51.69 1V8.24M12.59 66.18H54.59C58.65 66.18 60.67 66.18 62.22 65.39C63.58 64.7 64.69 63.59 65.38 62.23C66.17 60.68 66.17 58.65 66.17 54.6V19.83C66.17 15.77 66.17 13.75 65.38 12.2C64.69 10.84 63.58 9.73 62.22 9.04C60.67 8.25 58.64 8.25 54.59 8.25H12.59C8.53 8.25 6.51 8.25 4.96 9.04C3.6 9.73 2.49 10.84 1.8 12.2C1.01 13.75 1.01 15.78 1.01 19.83V54.59C1.01 58.65 1.01 60.67 1.8 62.22C2.49 63.58 3.6 64.69 4.96 65.38C6.51 66.17 8.54 66.17 12.59 66.17V66.18Z"
      stroke="#82A74D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const QouteIcon = () => (
  <svg
    width="112"
    height="69"
    viewBox="0 0 112 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7946 5.73L21.3906 2.61C18.894 1.16854 15.7015 2.02396 14.26 4.52065L2.60999 24.699C1.16853 27.1957 2.02396 30.3882 4.52065 31.8297L9.92465 34.9497C12.4213 36.3912 15.6138 35.5357 17.0553 33.039L28.7053 12.8607C30.1468 10.364 29.2913 7.17146 26.7946 5.73Z"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M101.438 36.5277L106.842 33.4077C109.339 31.9663 110.194 28.7738 108.753 26.2771L97.1025 6.09869C95.6611 3.602 92.4686 2.74657 89.9719 4.18804L84.5679 7.30803C82.0712 8.7495 81.2158 11.942 82.6572 14.4387L94.3072 34.6171C95.7487 37.1138 98.9412 37.9692 101.438 36.5277Z"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M83.0203 15.0905C83.0203 15.0905 79.3903 15.9705 71.3203 12.7105C66.8403 10.9105 61.8003 10.8905 57.3603 12.7905C56.4603 13.1805 55.5703 13.6405 54.7303 14.2105C50.7103 16.9205 44.2703 18.0505 41.2703 18.4505C40.2503 18.5905 39.5103 19.4905 39.5703 20.5205C39.7803 23.8605 41.8203 30.2505 54.7203 27.8705C57.0503 27.4405 59.4503 28.0405 61.3403 29.4605C63.2303 30.8805 65.8303 33.0805 69.6203 36.7105C71.9603 38.9605 74.2003 40.5305 76.2503 41.6205C80.6603 43.9705 86.1703 43.2205 89.5803 39.5705C90.8303 38.2305 92.7103 37.0105 95.5103 36.7105"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M65.4503 32.8706C65.4503 32.8706 70.0003 37.0106 78.6103 31.8306"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M31.2902 54.0406L35.7302 47.4106C41.8202 44.4306 46.3502 49.8406 46.3502 49.8406C56.3602 46.8606 54.7202 55.6106 54.7202 55.6106C54.7202 55.6106 58.4302 60.1906 53.8102 65.8506C49.1802 71.5106 46.3602 63.5406 46.3602 63.5406C38.5302 65.9106 38.9602 58.8506 38.9602 58.8506C31.9002 62.0806 31.2902 54.0406 31.2902 54.0406ZM31.2902 54.0406C22.8902 54.7106 25.6902 46.9206 25.6902 46.9206C23.5602 38.6406 16.3802 34.2006 16.3802 34.2006"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M46.3603 49.8406L38.9603 58.8406"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M46.3604 63.5305L54.7204 55.6005"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M25.7003 46.9105C25.7003 46.9105 33.4903 43.6205 35.7403 47.4005"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M71.5303 47.8806C72.7103 48.8506 74.1403 49.4506 75.5503 50.0406C76.6703 50.5106 77.8003 50.9706 78.9203 51.4406C79.1303 51.5306 79.3503 51.6206 79.5803 51.6506C79.8803 51.6906 80.1803 51.6506 80.4703 51.5906C81.8503 51.3506 83.3103 51.0206 84.7603 50.7006C87.0703 50.1906 88.6703 48.0006 88.2903 45.6606C88.2903 45.6506 88.2903 45.6306 88.2903 45.6206C88.0503 44.2606 87.4203 42.9106 86.3103 42.0806"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M64.1703 53.0005C66.3103 54.1105 68.4603 55.2205 70.6003 56.3305C71.3803 56.7405 72.1703 57.1405 73.0003 57.4505C74.2503 57.9105 75.5803 58.1305 76.9103 58.1605C77.4403 58.1705 77.9803 58.1505 78.4703 57.9405C79.5203 57.4805 80.0403 56.2505 80.0903 55.1005C80.1403 53.9505 79.8303 52.8205 79.7203 51.6805"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M75.2503 58.1805C75.2503 59.0405 75.2303 59.9105 74.9603 60.7305C74.6903 61.5505 74.1503 62.3105 73.3603 62.6605C72.8303 62.8905 72.2503 62.9105 71.6703 62.9305C68.8603 63.0205 64.8403 63.0205 62.0303 62.9305"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M60.6303 59.5906L61.1403 60.7206C61.4503 61.4106 61.7703 62.1206 61.7603 62.8806C61.7503 63.9306 61.0703 64.8906 60.1903 65.4606C59.3103 66.0306 58.2403 66.2406 57.2003 66.3106C56.2103 66.3706 55.1803 66.3106 54.2703 65.9006"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M29.1903 11.9705C30.6603 12.8305 32.4303 13.1505 34.1103 12.8705C34.8503 12.7505 35.5603 12.5105 36.2703 12.2805C38.8103 11.4505 41.3403 10.6205 43.8803 9.79046C44.4703 9.60046 45.0703 9.40046 45.6703 9.23046C47.3203 8.76046 49.0203 8.45046 50.7303 8.32046C51.0103 8.30046 51.3003 8.28046 51.5803 8.31046C51.9603 8.35046 52.3203 8.46046 52.6803 8.58046C54.8803 9.32046 57.1103 10.3305 58.5503 12.1505"
      stroke="#FF9000"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const SecureDeliveryIcon = () => (
  <svg
    width="64"
    height="68"
    viewBox="0 0 64 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.1015 33.89C56.2315 23.42 54.3315 14.64 54.3315 14.64C41.6115 19.93 28.2315 2 28.2315 2C28.2315 2 14.8515 19.92 2.1315 14.64C2.1315 14.64 -7.2885 58.08 28.2315 67C32.2115 66 35.6315 64.56 38.5615 62.8"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M59.2815 67H43.7715C42.8315 67 42.0515 66.3 41.9515 65.37L40.1915 49.38C40.0715 48.29 40.9215 47.34 42.0115 47.34H61.0415C62.1315 47.34 62.9815 48.29 62.8615 49.38L61.1015 65.37C61.0015 66.3 60.2115 67 59.2815 67Z"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M45.7415 47.35V41.07C45.9615 38.08 48.3915 35.74 51.2715 35.62C54.3315 35.49 57.0615 37.9 57.3015 41.07V47.35"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M14.3516 36.36L23.8116 45.82L42.6816 26.95"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const TrackVehicleIcon = () => (
  <svg
    width="69"
    height="66"
    viewBox="0 0 69 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.08 47.16C36.8267 47.16 47.16 36.8267 47.16 24.08C47.16 11.3333 36.8267 1 24.08 1C11.3333 1 1 11.3333 1 24.08C1 36.8267 11.3333 47.16 24.08 47.16Z"
      stroke="#44CC5E"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M41.77 38.89L68.01 65.13"
      stroke="#44CC5E"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M9.81006 34.61L19.3001 22.51L23.5801 31.26L37.9801 13.21"
      stroke="#44CC5E"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M38.57 11.98L36.53 13.01L38.45 14.26L38.57 11.98Z"
      stroke="#44CC5E"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M19.24 25.58C20.5379 25.58 21.59 24.5279 21.59 23.23C21.59 21.9321 20.5379 20.88 19.24 20.88C17.9421 20.88 16.89 21.9321 16.89 23.23C16.89 24.5279 17.9421 25.58 19.24 25.58Z"
      fill="#44CC5E"
    />
    <path
      d="M9.80996 36.58C11.1078 36.58 12.16 35.5279 12.16 34.23C12.16 32.9321 11.1078 31.88 9.80996 31.88C8.51209 31.88 7.45996 32.9321 7.45996 34.23C7.45996 35.5279 8.51209 36.58 9.80996 36.58Z"
      fill="#44CC5E"
    />
    <path
      d="M23.89 33.54C25.1879 33.54 26.24 32.4878 26.24 31.19C26.24 29.8921 25.1879 28.84 23.89 28.84C22.5922 28.84 21.54 29.8921 21.54 31.19C21.54 32.4878 22.5922 33.54 23.89 33.54Z"
      fill="#44CC5E"
    />
  </svg>
);

export const TowingServiceIcon = () => (
  <svg
    width="40"
    height="65"
    viewBox="0 0 40 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.775 7.80005H12.225C10.995 7.80005 9.855 8.46005 9.235 9.52005L1.465 22.99C0.845 24.06 0.845 25.37 1.465 26.44L9.235 39.9001C9.855 40.9701 10.995 41.62 12.225 41.62H27.775C29.005 41.62 30.145 40.9601 30.765 39.9001L38.535 26.44C39.155 25.37 39.155 24.06 38.535 22.99L30.765 9.53005C30.145 8.46005 29.005 7.81005 27.775 7.81005V7.80005Z"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M14.1949 1V7.8"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M25.8151 7.8V1"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M17.855 41.63V46.63C14.445 47.93 12.085 51.04 11.835 54.57C11.555 58.54 13.985 62.34 17.855 63.84C18.665 64.05 20.495 64.42 22.665 63.78C23.345 63.58 25.515 62.91 27.115 60.77C29.085 58.14 28.765 55.21 28.675 54.57C28.435 53.39 27.345 52.65 26.325 52.82C25.515 52.96 24.855 53.66 24.695 54.57C24.725 57.07 23.085 59.12 21.145 59.51C18.705 59.99 15.805 57.85 15.665 54.57C15.705 54.27 16.035 52 18.135 50.72C19.965 49.6 21.815 50.03 22.165 50.12V41.63"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M20.025 33.26C24.8465 33.26 28.755 29.3515 28.755 24.53C28.755 19.7086 24.8465 15.8 20.025 15.8C15.2036 15.8 11.295 19.7086 11.295 24.53C11.295 29.3515 15.2036 33.26 20.025 33.26Z"
      stroke="#E83F3F"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const EffortlessShippingIcon = () => (
  <svg
    width="73"
    height="67"
    viewBox="0 0 73 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_33_102)">
      <path
        d="M9.57 28.58H3.73C2.08419 28.58 0.75 29.9142 0.75 31.56V62.06C0.75 63.7058 2.08419 65.04 3.73 65.04H9.57C11.2158 65.04 12.55 63.7058 12.55 62.06V31.56C12.55 29.9142 11.2158 28.58 9.57 28.58Z"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.55 32.51C12.55 32.51 25.66 28.58 28.28 19.88C30.9 11.18 30.42 9.63001 30.42 9.63001C30.53 7.39001 32.38 5.61001 34.59 5.58001C36.85 5.55001 38.7701 7.35001 38.8801 9.63001V16.97C38.8801 19.15 38.75 21.33 38.5 23.5C38.23 25.82 37.89 29.03 37.69 31.68H64.4101C66.9601 31.68 69.2401 33.55 69.4801 36.09C69.7601 39 67.4701 41.46 64.6201 41.46H56.28"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M12.55 57.66C12.55 57.66 20.62 67.6 40.87 65.57"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M37.69 31.68C37.69 31.68 39 49.91 25.77 50.51"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M51.5599 48H44.4299C42.0883 48 40.1899 49.8983 40.1899 52.24V52.58C40.1899 54.9217 42.0883 56.82 44.4299 56.82H51.5599C53.9016 56.82 55.7999 54.9217 55.7999 52.58V52.24C55.7999 49.8983 53.9016 48 51.5599 48Z"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M48.64 56.82H41.51C39.1683 56.82 37.27 58.7183 37.27 61.06V61.4C37.27 63.7417 39.1683 65.64 41.51 65.64H48.64C50.9817 65.64 52.88 63.7417 52.88 61.4V61.06C52.88 58.7183 50.9817 56.82 48.64 56.82Z"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M52.4 39.19H45.27C42.9283 39.19 41.03 41.0883 41.03 43.43V43.77C41.03 46.1117 42.9283 48.01 45.27 48.01H52.4C54.7417 48.01 56.64 46.1117 56.64 43.77V43.43C56.64 41.0883 54.7417 39.19 52.4 39.19Z"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.67 1.77L50.8 11.42"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M56.63 10.59L59.85 0.220001"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M70.4599 9.75L60.5699 14.64"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M60.5699 20.12L71.7699 24.17"
        stroke="#82A74D"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_33_102">
        <rect width="72.02" height="66.59" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const VerifiedIcon = () => (
  <svg
    width="69"
    height="69"
    viewBox="0 0 69 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.5 68C53.0015 68 68 53.0015 68 34.5C68 15.9985 53.0015 1 34.5 1C15.9985 1 1 15.9985 1 34.5C1 53.0015 15.9985 68 34.5 68Z"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M16.1007 36.8194L26.8207 47.5394L52.8992 21.4609"
      stroke="#763CD6"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const CustomerCareIcon = () => (
  <svg
    width="61"
    height="66"
    viewBox="0 0 61 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_61_217)">
      <path
        d="M5.74866 32.7395V25.3862C5.74866 11.7814 16.8332 0.751373 30.5051 0.751373C44.1769 0.751373 55.2614 11.7814 55.2614 25.3862V32.7395"
        stroke="#E83F3F"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.64119 32.7395H10.7321V50.0009H4.64119C2.49677 50.0009 0.755066 48.2678 0.755066 46.1339V36.6066C0.755066 34.4727 2.49677 32.7395 4.64119 32.7395Z"
        stroke="#E83F3F"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M56.3588 50.0009H50.2679V32.7395H56.3588C58.5032 32.7395 60.2449 34.4727 60.2449 36.6066V46.1339C60.2449 48.2678 58.5032 50.0009 56.3588 50.0009Z"
        stroke="#E83F3F"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M56.0467 50.4918V56.9436C56.0467 59.7987 53.7211 62.1029 50.8618 62.1029H36.4147"
        stroke="#E83F3F"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M33.7972 58.7068H28.4915C27.057 58.7068 25.894 59.864 25.894 61.2915V62.664C25.894 64.0914 27.057 65.2487 28.4915 65.2487H33.7972C35.2317 65.2487 36.3946 64.0914 36.3946 62.664V61.2915C36.3946 59.864 35.2317 58.7068 33.7972 58.7068Z"
        stroke="#E83F3F"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_61_217">
        <rect width="61" height="66" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AboutIcon = () => (
  <svg
    width="47"
    height="55"
    viewBox="0 0 47 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.13994 8.26L24.5699 1L45.7699 8.32V30.69C45.7699 34.89 44.7999 39.07 42.7199 42.72C40.0499 47.41 35.0899 52.41 25.9399 53.63C25.9399 53.63 11.1099 55.27 4.32994 42.39C2.77994 39.44 1.98994 36.15 1.82994 32.82C1.47994 25.68 0.689944 8.7 1.12994 8.27L1.13994 8.26Z"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M12.06 25.86L22.44 36.85L40.28 19"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const EchoFriendlyIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.8318 54.36C44.3024 54.36 54.4118 44.2506 54.4118 31.78C54.4118 19.3094 44.3024 9.20001 31.8318 9.20001C19.3612 9.20001 9.25177 19.3094 9.25177 31.78C9.25177 44.2506 19.3612 54.36 31.8318 54.36Z"
      stroke="#39DF32"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M4.71178 36.35C4.94178 37.89 6.03178 43.73 9.63178 48.26C9.84178 48.52 9.89178 48.87 9.76178 49.17L9.04178 50.83C8.92178 51.1 8.95178 51.42 9.10178 51.67L11.7918 54.42C11.9918 54.74 11.9318 54.61 12.0418 54.82L14.9718 54.1C15.2118 54.05 15.4518 54.09 15.6518 54.22C17.1318 55.19 23.5418 59.22 27.5318 59.32C27.8818 59.32 28.1918 59.51 28.3318 59.83L29.2818 62.02C29.4218 62.35 29.7518 62.56 30.1018 62.56H33.7218C34.1318 62.56 34.4818 62.29 34.5918 61.9L34.9518 60.59C35.0418 60.26 35.3018 60.01 35.6318 59.95C37.6918 59.53 45.1718 57.81 48.2318 54.46C48.4818 54.19 48.8718 54.12 49.2118 54.26L51.3418 55.13C51.6618 55.26 52.0318 55.19 52.2918 54.96L54.8118 52.65C55.1018 52.38 55.1918 51.95 55.0118 51.59L54.1918 49.93C54.0518 49.65 54.0718 49.32 54.2418 49.05C55.2218 47.53 58.5118 42.08 59.2518 36.32C59.2918 36.01 59.4918 35.74 59.7818 35.61L62.0718 34.62C62.4018 34.48 62.6118 34.15 62.6118 33.8V30.24C62.6118 29.84 62.3418 29.48 61.9518 29.38L60.5518 28.99C60.2318 28.9 59.9818 28.64 59.9118 28.31C59.4918 26.25 57.7818 18.74 54.4318 15.69C54.1618 15.45 54.0918 15.05 54.2318 14.71L55.1218 12.51C55.2518 12.2 55.1918 11.85 54.9818 11.59L53.2118 9.49C52.9818 9.22 52.6218 9.11 52.2918 9.2L49.8518 9.87C49.5918 9.94 49.3218 9.89 49.1018 9.74C47.5518 8.67 41.0218 4.35 35.6018 3.99C35.2918 3.97 35.0218 3.81 34.8718 3.54L33.7018 1.46C33.5418 1.18 33.2418 1 32.9218 1H30.9818C30.6618 1 30.3618 1.17 30.2018 1.45L29.0318 3.51C28.9118 3.72 28.7218 3.87 28.4818 3.93C26.6118 4.42 17.9618 6.8 15.6118 9.45C15.3518 9.74 14.9518 9.85 14.5818 9.7L12.4018 8.8C12.0818 8.67 11.7218 8.73 11.4618 8.96L9.41178 10.77C9.15178 11 9.05178 11.36 9.14178 11.69L9.84178 14.11C9.91178 14.34 9.88178 14.58 9.76178 14.79C8.85178 16.43 4.75178 23.93 4.60178 27.58C4.59178 27.91 4.38178 28.19 4.09178 28.33L1.65178 29.48C1.35178 29.62 1.15178 29.92 1.14178 30.25L1.00178 33C0.981777 33.31 1.13178 33.61 1.39178 33.79L4.28178 35.75C4.49178 35.89 4.63178 36.11 4.66178 36.36L4.71178 36.35Z"
      stroke="#39DF32"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M35.3718 31C35.3718 31 34.4518 28.84 36.0718 28.04C37.5718 27.3 41.0818 27.27 42.5618 26.07C42.7018 25.96 42.9118 26.05 42.9218 26.23C43.0418 27.81 42.9318 32.93 36.8118 33.82"
      stroke="#39DF32"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M28.3018 31C28.3018 31 29.2218 28.84 27.6018 28.04C26.1818 27.33 22.9318 27.27 21.3518 26.24C21.0918 26.07 20.7518 26.22 20.7418 26.53C20.6718 28.37 21.0918 32.99 26.8718 33.82"
      stroke="#39DF32"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M24.6418 29.78C24.6418 29.78 31.0518 31.73 31.8318 34.87M31.8318 34.87V41.6M31.8318 34.87C32.6118 31.74 39.0218 29.78 39.0218 29.78"
      stroke="#39DF32"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const BuildingTrustIcon = () => (
  <svg
    width="65"
    height="60"
    viewBox="0 0 65 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.1456 59.0466C8.45556 41.7766 1.90556 28.4366 1.07556 19.6266C0.335557 11.8166 5.09556 4.32665 12.5256 1.78665C23.7756 -2.07335 32.1556 9.52665 32.1556 9.52665C32.1556 9.52665 40.5356 -2.06335 51.7856 1.78665C59.2056 4.33665 63.9756 11.8166 63.2356 19.6266C62.3956 28.4466 55.8556 41.7766 32.1556 59.0466H32.1456Z"
      stroke="#ED1C24"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const DriveBySatisfactionIcon = () => (
  <svg
    width="45"
    height="57"
    viewBox="0 0 45 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.6401 25.3C31.3503 25.3 36.7901 19.8603 36.7901 13.15C36.7901 6.43974 31.3503 1 24.6401 1C17.9298 1 12.4901 6.43974 12.4901 13.15C12.4901 19.8603 17.9298 25.3 24.6401 25.3Z"
      stroke="#0000CC"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M24.79 31.36C24.79 31.36 3.84 31.92 1 55.51L25.81 55.29"
      stroke="#0000CC"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M35.09 55.51C28.74 50.88 26.98 47.3 26.76 44.94C26.56 42.85 27.84 40.84 29.83 40.16C32.85 39.13 35.09 42.23 35.09 42.23C35.09 42.23 37.34 39.12 40.35 40.16C42.34 40.84 43.62 42.85 43.42 44.94C43.2 47.3 41.44 50.88 35.09 55.51Z"
      stroke="#0000CC"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
);

export const AuthorityIcon = () => (
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_297_1865)">
      <path
        d="M62.4 63.8H34.6V62.2C34.6 58.7 37.4 55.9 40.9 55.9H56.1C59.6 55.9 62.4 58.7 62.4 62.2V63.8Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M54.5 52.5H43.2V55.8H54.5V52.5Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M48.5 36.3C48.5 36.3 43.4 35.6 43.4 41.4L44 43.2C44.8 45.4 44.8 47.7 44.1 49.9L43.2 52.5"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M49.2 36.3C49.2 36.3 54.3 35.6 54.3 41.4L53.7 43.2C52.9 45.4 52.9 47.7 53.6 49.9L54.5 52.5"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M48.5 32.7001V0.800049H8.8L4.7 4.70005L0.800003 8.70005V56.5H32.8"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.2 5H27.4"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M45.2 9.19995H14.2"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M32.6 51.8H8.8"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M22.6 41.9001C28.8408 41.9001 33.9 36.8409 33.9 30.6C33.9 24.3592 28.8408 19.3 22.6 19.3C16.3592 19.3 11.3 24.3592 11.3 30.6C11.3 36.8409 16.3592 41.9001 22.6 41.9001Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M22.6 45.9001C31.05 45.9001 37.9 39.05 37.9 30.6C37.9 22.1501 31.05 15.3 22.6 15.3C14.15 15.3 7.3 22.1501 7.3 30.6C7.3 39.05 14.15 45.9001 22.6 45.9001Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M9.99999 2.09998V9.99998H2.39999"
        stroke="#CB1E0A"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_297_1865">
        <rect width="63.2" height="64.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExpertiseIcon = () => (
  <svg
    width="63"
    height="55"
    viewBox="0 0 63 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_297_1858)">
      <path
        d="M24 17C23.5 15 21.8 13.6 19.7 13.6H14.4V10.2C16.2 9.50005 17.4 7.70005 17.4 5.70005C17.4 3.00005 15.2 0.800049 12.5 0.800049C9.80001 0.800049 7.50001 2.90005 7.50001 5.70005C7.50001 7.70005 8.70001 9.50005 10.5 10.2V13.6H5.20001C2.70001 13.6 0.700012 15.6 0.700012 18.1V21.9H14.6"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M38.5 17C39 15 40.7 13.6 42.8 13.6H48.1V10.2C46.3 9.50005 45.1 7.70005 45.1 5.70005C45.1 3.00005 47.3 0.800049 50 0.800049C52.7 0.800049 54.9 3.00005 54.9 5.70005C54.9 7.70005 53.7 9.50005 51.9 10.2V13.6H57.2C59.7 13.6 61.7 15.6 61.7 18.1V21.9H47.9"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M40.9 18.8H33.8V14.3C36.1 13.3 37.8 11 37.8 8.30005C37.8 4.70005 34.9 1.80005 31.3 1.80005C27.7 1.80005 24.8 4.70005 24.8 8.30005C24.8 11 26.4 13.3 28.8 14.3V18.8H21.7C18.4 18.8 15.8 21.5001 15.8 24.7001V29.8H46.7V24.7001C46.8 21.5001 44.1 18.8 40.9 18.8Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M11.7 30.1L13.7 34.1L18.1 34.8L14.9 37.9L15.6 42.3L11.7 40.2L7.69999 42.3L8.49999 37.9L5.29999 34.8L9.69999 34.1L11.7 30.1Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M50.2 30.1L52.2 34.1L56.6 34.8L53.4 37.9L54.1 42.3L50.2 40.2L46.2 42.3L47 37.9L43.8 34.8L48.2 34.1L50.2 30.1Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M31.3 34.8L34.2 40.7001L40.7 41.6L36 46.2001L37.1 52.7001L31.3 49.6L25.5 52.7001L26.6 46.2001L21.9 41.6L28.4 40.7001L31.3 34.8Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_297_1858">
        <rect width="62.5" height="54.1" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TransparencyIcon = () => (
  <svg
    width="63"
    height="57"
    viewBox="0 0 63 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_297_1852)">
      <path
        d="M58.6 38.1C58.6 36.2 57 34.6 55.1 34.6C57 34.6 58.6 33 58.6 31.1C58.6 29.2 57 27.6 55.1 27.6H51.5H37.5L38.6 22C39 20.1 37.8 18.3 36 17.9C34.1 17.4 32.1 18.6 31.7 20.5L29.9 27.7H27.7H0.799988V55.4H27.1C27.3 55.4 27.5 55.5 27.7 55.5H55.2C57.1 55.5 58.7 53.9 58.7 52C58.7 50.1 57.1 48.5 55.2 48.5C57.1 48.5 58.7 46.9 58.7 45C58.7 43.1 57.1 41.5 55.2 41.5C57.1 41.6 58.6 40 58.6 38.1Z"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M5.79999 25.3V9.40002H12.4C17.3 9.40002 22.1 8.00002 26.3 5.50002L33.8 0.900024L40.4 5.10002C44.7 7.90002 49.7 9.30002 54.8 9.30002H61.8V49.1C61.8 52.6 59 55.4 55.5 55.4"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M9.20001 19V13.2H14.9C18.7 13.2 22.5 12.2 25.9 10.2L29.7 8"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M57.7 19V13.2H52C48.2 13.2 44.4 12.2 41 10.2L37.2 8"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M9.20001 28.1V55.4"
        stroke="#CB1E0A"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_297_1852">
        <rect width="62.5" height="56.2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="13"
    height="25"
    viewBox="0 0 13 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="13" height="24.0377" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_61_207"
          transform="matrix(0.05 0 0 0.0270408 0 -0.00025512)"
        />
      </pattern>
      <image
        id="image0_61_207"
        width="20"
        height="37"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M17.169 2.293H7.16901C4.40758 2.293 2.16901 4.53158 2.16901 7.293V17.293C2.16901 20.0544 4.40758 22.293 7.16901 22.293H17.169C19.9304 22.293 22.169 20.0544 22.169 17.293V7.293C22.169 4.53158 19.9304 2.293 17.169 2.293Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M16.169 11.663C16.2924 12.4952 16.1503 13.3452 15.7628 14.092C15.3753 14.8388 14.7622 15.4444 14.0106 15.8227C13.2591 16.2009 12.4075 16.3326 11.5768 16.1989C10.7461 16.0653 9.97878 15.6731 9.38386 15.0782C8.78894 14.4832 8.39675 13.7159 8.26309 12.8852C8.12942 12.0546 8.26108 11.2029 8.63934 10.4514C9.01761 9.69985 9.6232 9.08674 10.37 8.69924C11.1168 8.31174 11.9668 8.16959 12.799 8.293C13.6479 8.41888 14.4339 8.81446 15.0407 9.42131C15.6476 10.0281 16.0431 10.8141 16.169 11.663Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M17.669 6.793H17.679"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
);

export const LinkedinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M5.14398 22.3385H0.563976V7.58948H5.14398V22.3385ZM2.85098 5.57748C2.32373 5.58083 1.80734 5.42772 1.36714 5.13751C0.926944 4.8473 0.582722 4.43303 0.378032 3.94713C0.173342 3.46124 0.117382 2.92554 0.217235 2.40782C0.317088 1.89011 0.568265 1.41365 0.938984 1.03873C1.3097 0.663815 1.7833 0.407287 2.29986 0.301608C2.81641 0.19593 3.35271 0.245851 3.84088 0.445054C4.32906 0.644258 4.74717 0.983792 5.04232 1.42069C5.33747 1.85759 5.49639 2.37223 5.49898 2.89948C5.4998 3.6048 5.22203 4.2819 4.72611 4.78344C4.23019 5.28498 3.55626 5.57036 2.85098 5.57748ZM22.286 22.3385H17.716V15.1585C17.716 13.4475 17.681 11.2535 15.335 11.2535C12.954 11.2535 12.589 13.1125 12.589 15.0355V22.3355H8.01298V7.58948H12.406V9.60147H12.47C12.9089 8.85023 13.5432 8.232 14.3055 7.81256C15.0678 7.39312 15.9295 7.18816 16.799 7.21948C21.434 7.21948 22.286 10.2715 22.286 14.2365V22.3365V22.3385Z"
      fill="white"
    ></path>
  </svg>
);

export const ContactIcon = () => (
  <svg
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_65_241)">
      <path
        d="M0.99998 5.85999C0.99998 22.51 14.49 36 31.14 36C31.89 36 32.64 35.97 33.37 35.92C34.22 35.86 34.64 35.83 35.02 35.61C35.34 35.43 35.64 35.1 35.8 34.77C35.99 34.37 35.99 33.9 35.99 32.97V27.49C35.99 26.7 35.99 26.31 35.86 25.98C35.75 25.68 35.56 25.42 35.32 25.21C35.05 24.97 34.68 24.84 33.94 24.57L27.7 22.3C26.84 21.99 26.41 21.83 26.01 21.86C25.65 21.88 25.31 22.01 25.01 22.21C24.68 22.45 24.44 22.84 23.97 23.62L22.37 26.28C17.22 23.95 13.04 19.76 10.7 14.61L13.36 13.01C14.14 12.54 14.53 12.31 14.77 11.97C14.98 11.68 15.1 11.33 15.12 10.97C15.15 10.56 14.99 10.13 14.68 9.27999L12.41 3.03999C12.14 2.29999 12.01 1.92999 11.77 1.65999C11.56 1.41999 11.3 1.22999 11 1.11999C10.66 0.98999 10.27 0.98999 9.48998 0.98999H4.00998C3.07998 0.98999 2.60998 0.98999 2.20998 1.17999C1.87998 1.33999 1.54998 1.63999 1.36998 1.95999C1.14998 2.34999 1.11998 2.76999 1.05998 3.60999C1.00998 4.34999 0.97998 5.08999 0.97998 5.83999L0.99998 5.85999Z"
        stroke="#CB1E0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_65_241">
        <rect width="37" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EmailIcon = () => (
  <svg
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_65_244)">
      <path
        d="M3.1 33.9L13.62 23.38M36.76 33.9L26.24 23.38M1.06 14.96L16.2 25.09C17.55 25.99 18.22 26.44 18.95 26.61C19.59 26.76 20.27 26.76 20.91 26.61C21.64 26.44 22.31 25.99 23.66 25.09L38.8 14.96M16.35 2.49L4.15 10.15C3 10.87 2.42 11.23 2.01 11.72C1.64 12.15 1.36 12.65 1.19 13.2C1 13.81 1 14.49 1 15.85V29.27C1 31.63 1 32.8 1.46 33.7C1.86 34.49 2.51 35.14 3.3 35.54C4.2 36 5.38 36 7.73 36H32.13C34.49 36 35.66 36 36.56 35.54C37.35 35.14 38 34.49 38.4 33.7C38.86 32.8 38.86 31.62 38.86 29.27V15.85C38.86 14.49 38.86 13.81 38.67 13.2C38.5 12.66 38.22 12.15 37.85 11.72C37.43 11.23 36.86 10.87 35.71 10.15L23.51 2.49C22.21 1.67 21.56 1.27 20.87 1.11C20.25 0.970005 19.61 0.970005 19 1.11C18.3 1.27 17.65 1.68 16.36 2.49H16.35Z"
        stroke="#CB1E0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_65_244">
        <rect width="39.86" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LocationIcon = () => (
  <svg
    width="30"
    height="37"
    viewBox="0 0 30 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_65_247)">
      <path
        d="M14.61 36C21.42 29 28.22 22.73 28.22 15C28.22 7.27 22.13 1 14.61 1C7.09 1 1 7.27 1 15C1 22.73 7.81 29 14.61 36Z"
        stroke="#CB1E0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6102 18.5C16.7602 18.5 18.5002 16.76 18.5002 14.61C18.5002 12.46 16.7602 10.72 14.6102 10.72C12.4602 10.72 10.7202 12.46 10.7202 14.61C10.7202 16.76 12.4602 18.5 14.6102 18.5Z"
        stroke="#CB1E0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_65_247">
        <rect width="29.22" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhatsappIcon = () => (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 29C21.732 29 28 22.732 28 15C28 7.26801 21.732 1 14 1C6.26801 1 0 7.26801 0 15C0 17.5109 0.661 19.8674 1.81847 21.905L0 29L7.31486 27.3038C9.3014 28.3854 11.5789 29 14 29ZM14 26.8462C20.5425 26.8462 25.8462 21.5425 25.8462 15C25.8462 8.4576 20.5425 3.15385 14 3.15385C7.45755 3.15385 2.15385 8.4576 2.15385 15C2.15385 17.5261 2.9445 19.8675 4.29184 21.7902L3.23077 25.7692L7.27993 24.7569C9.1894 26.0746 11.5046 26.8462 14 26.8462Z"
      fill="#BFC8D0"
    />
    <path
      d="M26 14C26 20.6274 20.6274 26 14 26C11.4722 26 9.1269 25.2184 7.19266 23.8837L3.09091 24.9091L4.16576 20.8784C2.80092 18.9307 2 16.5589 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14Z"
      fill="url(#paint0_linear_56_72)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 16.5109 0.661 18.8674 1.81847 20.905L0 28L7.31486 26.3038C9.3014 27.3854 11.5789 28 14 28ZM14 25.8462C20.5425 25.8462 25.8462 20.5425 25.8462 14C25.8462 7.45755 20.5425 2.15385 14 2.15385C7.45755 2.15385 2.15385 7.45755 2.15385 14C2.15385 16.5261 2.9445 18.8675 4.29184 20.7902L3.23077 24.7692L7.27993 23.7569C9.1894 25.0746 11.5046 25.8462 14 25.8462Z"
      fill="white"
    />
    <path
      d="M10.5 7.49989C10.1672 6.83131 9.6565 6.8905 9.1407 6.8905C8.2188 6.8905 6.78125 7.99478 6.78125 10.05C6.78125 11.7343 7.52345 13.578 10.0244 16.3361C12.438 18.9979 15.6094 20.3748 18.2422 20.3279C20.875 20.2811 21.4167 18.0154 21.4167 17.2503C21.4167 16.9112 21.2062 16.742 21.0613 16.696C20.1641 16.2654 18.5093 15.4631 18.1328 15.3124C17.7563 15.1617 17.5597 15.3656 17.4375 15.4765C17.0961 15.8018 16.4193 16.7608 16.1875 16.9765C15.9558 17.1922 15.6103 17.083 15.4665 17.0015C14.9374 16.7892 13.5029 16.1511 12.3595 15.0426C10.9453 13.6718 10.8623 13.2001 10.5959 12.7803C10.3828 12.4444 10.5392 12.2384 10.6172 12.1483C10.9219 11.7968 11.3426 11.254 11.5313 10.9843C11.7199 10.7145 11.5702 10.305 11.4803 10.05C11.0938 8.953 10.7663 8.0347 10.5 7.49989Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_56_72"
        x1="24.5"
        y1="5"
        x2="2"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BD066" />
        <stop offset="1" stop-color="#27B43E" />
      </linearGradient>
    </defs>
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 3C8.58579 3 8.25 3.33579 8.25 3.75V6H3.75C3.33579 6 3 6.33579 3 6.75C3 7.16421 3.33579 7.5 3.75 7.5H9H15H20.25C20.6642 7.5 21 7.16421 21 6.75C21 6.33579 20.6642 6 20.25 6H15.75V3.75C15.75 3.33579 15.4142 3 15 3H9ZM14.25 6V4.5H9.75V6H14.25ZM6.75 9.75C6.75 9.33579 6.41421 9 6 9C5.58579 9 5.25 9.33579 5.25 9.75V18.75C5.25 19.3467 5.48705 19.919 5.90901 20.341C6.33097 20.7629 6.90326 21 7.5 21H16.5C17.0967 21 17.669 20.7629 18.091 20.341C18.5129 19.919 18.75 19.3467 18.75 18.75V9.75C18.75 9.33579 18.4142 9 18 9C17.5858 9 17.25 9.33579 17.25 9.75V18.75C17.25 18.9489 17.171 19.1397 17.0303 19.2803C16.8897 19.421 16.6989 19.5 16.5 19.5H7.5C7.30109 19.5 7.11032 19.421 6.96967 19.2803C6.82902 19.1397 6.75 18.9489 6.75 18.75V9.75ZM12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V12C11.25 11.5858 11.5858 11.25 12 11.25ZM9.75 12C9.75 11.5858 9.41421 11.25 9 11.25C8.58579 11.25 8.25 11.5858 8.25 12V16.5C8.25 16.9142 8.58579 17.25 9 17.25C9.41421 17.25 9.75 16.9142 9.75 16.5V12ZM15 11.25C15.4142 11.25 15.75 11.5858 15.75 12V16.5C15.75 16.9142 15.4142 17.25 15 17.25C14.5858 17.25 14.25 16.9142 14.25 16.5V12C14.25 11.5858 14.5858 11.25 15 11.25Z"
      fill="#E55050"
    />
  </svg>
);
